import { Divider, SegmentedControl, Tooltip } from '@mantine/core';
import type { ReactNode } from 'react';

import { AppointmentMode } from '@/utils/practitioner/bookingFormOptionsUtils.ts';

interface Props {
    selectedMode: AppointmentMode;
    disabled?: boolean;
    onChange: (val: AppointmentMode) => void;
    data: { label: string; value: AppointmentMode; disabled?: boolean; disableText?: string }[];
    children?: ReactNode;
}

export const AppointmentModeSelector = ({ disabled, selectedMode, onChange, data, children }: Props) => {
    // Map data to inject Tooltip for disabled options
    const mappedData = data.map((item) =>
        item.disabled && item.disableText && !disabled
            ? {
                  ...item,
                  label: (
                      <Tooltip label={item.disableText} multiline className="max-w-md">
                          <div
                              data-testid={`appointment-mode-tooltip-trigger-${item.value}`}
                              style={{ cursor: 'not-allowed' }}
                          >
                              {item.label}
                          </div>
                      </Tooltip>
                  ),
              }
            : item
    );
    return (
        <div className="mt-3 flex flex-col gap-3">
            <Divider />
            {children}
            <div className="flex items-center gap-3">
                <span className="text-sm font-bold">Terminmodus</span>
                <SegmentedControl
                    disabled={disabled}
                    size="sm"
                    value={selectedMode}
                    onChange={(val: string) => onChange(val as AppointmentMode)}
                    data={mappedData}
                />
            </div>
        </div>
    );
};
